import Text from "./Text";
export default Text;
export * from "./Text";
